import { useTranslation } from "react-i18next";

import type { toAreaGeoItemEntryRows } from "~/features/recordGeoItems/hooks";

type AreaGeoItemEntryRow = ReturnType<typeof toAreaGeoItemEntryRows>[number];

/** The record_geo_item properties of each link, one block per entry. */
export function AreaGeoItemEntryList({ entries }: { entries: readonly AreaGeoItemEntryRow[] }) {
  const { t } = useTranslation();
  return entries.map((entry, index) => (
    <div key={index} className="space-y-3 border-t border-border-default pt-3 first:border-t-0 first:pt-0">
      {entry.label && (
        <AreaDetailField label={t("ui.label")}>
          <span className="text-fg-1">{entry.label}</span>
        </AreaDetailField>
      )}
      <AreaDetailField label={t("ui.date")}>
        <span className="tabular-nums text-fg-1">
          {entry.date || "—"} ~ {entry.endDate || "—"}
        </span>
      </AreaDetailField>
      {entry.memo && (
        <AreaDetailField label={t("model.recordGeoItem.memo")}>
          <span className="whitespace-pre-line text-fg-1">{entry.memo}</span>
        </AreaDetailField>
      )}
    </div>
  ));
}

export function AreaDetailField({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="grid grid-cols-[minmax(6rem,9rem)_1fr] items-start gap-4">
      <span className="text-12-bold text-fg-2">{label}</span>
      <div>{children}</div>
    </div>
  );
}
